<!-- To use a transparent background with this iframe, use <iframe src="stuff.htm" allowtransparency="true"></iframe> -->
<!-- <div *ngIf="!awaitingResponse else loading"> -->
@if (loaded) {
  <div class="wrapper" role="main">
    <mat-card class="saldo-checker">
      <div class="imgWrapper">
        <img [src]="townshipImage" alt="logo" class="logo" />
      </div>
      <mat-card-content>
        <div class="title" role="heading" aria-level="1">
          {{ 'saldo-checker.header-message' | translate }}
        </div>
        <p class="info">
          {{ 'saldo-checker.info-message' | translate: environmentObj }}
        </p>
        @if (!value) {
          <form
            class="saldo-form"
            aria-label="zoeken op bonnummer"
            (ngSubmit)="checkSaldo()"
            [formGroup]="saldoCheckerForm"
          >
            <mat-form-field class="form-field-width">
              <mat-label>{{ environmentObj.value }}{{ ('input.coupon' | translate).toLowerCase() }}</mat-label>
              <input #voucherInput formControlName="voucher" autocomplete="off" matInput required />
              <mat-error>
                {{ getError('voucher') }}
              </mat-error>
              <mat-error>
                {{ error }}
              </mat-error>
            </mat-form-field>
            <div class="info-voucher">
              {{ 'saldo-checker.info-voucher' | translate: environmentObj }}
            </div>
          </form>
        }
        @if (value) {
          <div class="balance-check">
            @if (showValue) {
              <div class="valid">
                {{ 'saldo-checker.start-balance' | translate }}
              </div>
              <p class="info">€{{ originalValue }}</p>
              @if (showRemaining) {
                <div class="balance">
                  {{ 'saldo-checker.current-balance' | translate }}
                </div>
                <p class="balance-text">€{{ value }}</p>
              }
            }
            @if (showDate) {
              <div class="valid">{{ 'saldo-checker.validity' | translate }}</div>
              @if (resultDate) {
                <p class="result-date">
                  {{ resultDate }}
                </p>
              }
            }
          </div>
        }
        @if (resultString) {
          <mat-error class="result-string">{{ resultString }}</mat-error>
        }
      </mat-card-content>
      <mat-card-actions class="mat-card-actions">
        @if (!value) {
          <button
            class="request-button"
            [class.spinner]="awaitingResponse"
            (click)="checkSaldo()"
            [disabled]="!saldoCheckerForm.valid"
            mat-flat-button
          >
            {{ 'request-digital.button.request' | translate }}
          </button>
        }
        @if (value) {
          <button class="request-button" [class.spinner]="awaitingResponse" (click)="reset()" mat-flat-button>
            {{ 'request-digital.button.again' | translate }}
          </button>
        }
      </mat-card-actions>
    </mat-card>
  </div>
} @else {
  <div class="loading-wrapper">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
<!-- </div> -->
